module.exports = __webpack_public_path__ + "static/media/icon_webinar.c0b54828.svg";